import { useState } from 'react'
import { Icon } from '../../icon'
import { BaseField, ValidationIcon } from '../base-field/BaseField'
import { Input } from '../base-field/input'
import styles from './PasswordField.module.css'
import { PasswordFieldProps } from './PasswordField.types'
import { PasswordHelperRules } from './PasswordHelperRules'

export function PasswordField(props: PasswordFieldProps) {
  const {
    name,
    disabled,
    ariaLabel,
    status,
    value,
    onChange,
    showPasswordLabel,
    hidePasswordLabel,
    helperRules,
    placeholder,
    inputProps,
    ...rest
  } = props
  const [visible, setVisible] = useState(false)
  const toggleVisibility = () => setVisible(prevState => !prevState)

  return (
    <div className={styles.passwordFieldWrapper}>
      <BaseField
        {...rest}
        name={name}
        disabled={disabled}
        status={status}
      >
        <Input
          id={name}
          name={name}
          disabled={disabled}
          value={value}
          aria-label={ariaLabel}
          onChange={onChange}
          placeholder={placeholder}
          {...inputProps}
          type={visible ? 'text' : 'password'}
        />
        <ValidationIcon status={status ?? 'default'} />
        <button
          className={styles.iconPswdBtn}
          type="button"
          onClick={toggleVisibility}
          aria-pressed={visible}
          aria-label={visible ? hidePasswordLabel : showPasswordLabel}
        >
          <Icon size={20} glyph={visible ? 'EyeSlashed' : 'Eye'} />
        </button>
      </BaseField>
      {helperRules && helperRules.length > 0 && (
        <PasswordHelperRules rules={helperRules} />
      )}
    </div>
  )
}
